// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__33ya0","content":"Footer_content__3jaHw"};